import { MenuItem } from "./types";
import { Permission } from "src/store/api/generatedApi";

export const flattenMenuItems = (
  menuItems: MenuItem[],
  prefix = ""
): MenuItem[] => {
  const result: MenuItem[] = [];

  for (const item of menuItems) {
    result.push({ ...item, path: prefix + item.path });
    if (item.children) {
      result.push(...flattenMenuItems(item.children, prefix));
    }
  }

  return result;
};

export const getMenuItemPermissions = (menuItem: MenuItem): Permission[] => [
  ...(menuItem.requiredPermissions ?? []),
  ...(menuItem.permissionsToCheck ?? []),
];
